import React, { forwardRef } from "react"

import FourSimpleViewSVG from '../../svgs/FourSimpleViewSVG'
import FourDetailedViewSVG from '../../svgs/FourDetailedViewSVG'
import FiveViewSVG from '../../svgs/FiveViewSVG'
import OneViewSVG from '../../svgs/OneViewSVG'
import TwoViewSVG from '../../svgs/TwoViewSVG'
import SummaryViewSVG from '../../svgs/SummaryViewSVG'

const CurrentSceneSVG = forwardRef(({currentScene, width, color}, ref) => {
  switch(currentScene) {
    case('4_view_simple'):
      return (<FourSimpleViewSVG ref={ref} width={width} color={color} />)
    case('4_view_detailed'):
      return (<FourDetailedViewSVG ref={ref} width={width} color={color} />)
    case('5_view'):
      return (<FiveViewSVG ref={ref} width={width} color={color} />)
    case('2_view'):
      return (<TwoViewSVG ref={ref} width={width} color={color} />)
    case('1_view'):
      return (<OneViewSVG ref={ref} width={width} color={color} />)
    case('summary'):
      return (<SummaryViewSVG ref={ref} width={width} color={color} />)
    default:
      return (<>no svg found for scene {currentScene}<br/>TELL DAN</>)
  }
})

export default CurrentSceneSVG
